import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'

import Matches from 'components/matches/Matches'
import NoMatches from 'components/matches/NoMatches'
import * as appActions from 'lib/store/app'
import * as userActions from 'lib/store/user'

export class MatchesContainer extends React.PureComponent {
  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
    matches: PropTypes.array.isRequired,
    userProfile: PropTypes.object.isRequired,
    history: PropTypes.object,
    location: PropTypes.object,
    setLoading: PropTypes.func.isRequired,
    fetchUserProfile: PropTypes.func.isRequired,
    fetchMatches: PropTypes.func.isRequired,
    deleteMatch: PropTypes.func.isRequired
  }

  componentDidMount() {
    document.title = 'Matches'

    Promise.all([
      this.props.fetchUserProfile(),
      this.props.fetchMatches()
    ]).then(() => {
      const { userLink } = this.props.userProfile
      if (!userLink) {
        this.props.history.replace('/login', {
          referrer: this.props.location.pathname
        })
        return
      }

      this.props.setLoading(false)
    })
  }

  getUserLinkUrl = match => {
    const targetUrl = match.facebookId
      ? `https://m.me/${match.facebookId}`
      : match.userLink

    return targetUrl
  }

  handleSendMessage = match => {
    window.location.href = this.getUserLinkUrl(match)
  }

  handleNoMatchesAction = () => {
    this.props.setLoading(true)
    this.props.history.replace('/likedislike')
  }

  handleMatchClick = match => () => {
    this.props.history.replace(`/match-profile/${match.senderId}`)
  }

  handleDeleteMatch = match => () => {
    this.props.deleteMatch(match)
  }

  generateHandleMessageForEachMatch = match => () => {
    this.handleSendMessage(match)
  }

  render() {
    const { matches, isLoading } = this.props
    if (isLoading) return null

    if (matches.length < 1) {
      return <NoMatches onActionClick={this.handleNoMatchesAction} />
    }

    return (
      <Matches
        matches={matches}
        onSendMessage={this.generateHandleMessageForEachMatch}
        onMatchClick={this.handleMatchClick}
        onDeleteMatch={this.handleDeleteMatch}
      />
    )
  }
}

const mapStateToProps = state => ({
  isLoading: state.app.isLoading,
  matches: state.user.matches.map(matchId => state.crushes.entities[matchId]),
  userProfile: state.user.profile
})

const mapDispatchToProps = dispatch => ({
  setLoading: loadingState => dispatch(appActions.setLoading(loadingState)),
  fetchMatches: () => dispatch(userActions.fetchMatches()),
  fetchUserProfile: () => dispatch(userActions.fetchUserProfile()),
  deleteMatch: match => dispatch(userActions.deleteMatch(match))
})

export const MatchesConnected = connect(mapStateToProps, mapDispatchToProps)(
  MatchesContainer
)

export default withRouter(MatchesConnected)



// WEBPACK FOOTER //
// ./src/components/matches/MatchesContainer.js